import type { ColorMap } from './types';

export const TEST_ID = 'wearBar';

export const MINIMUM_PERCENT = 0;

export const FULL_PERCENT = 100;

export const LOW_THRESHOLD = 0;

export const MEDIUM_THRESHOLD = 15;

export const HIGH_THRESHOLD = 50;

export const COLOR_MAP: ColorMap = {
    [HIGH_THRESHOLD]: 'var(--wear-bar-high-color)',
    [LOW_THRESHOLD]: 'var(--wear-bar-low-color)',
    [MEDIUM_THRESHOLD]: 'var(--wear-bar-medium-color)'
};

export const FILL_COLOR_VARIABLE = '--wear-bar-fill-color';

export const FILL_WIDTH_VARIABLE = '--wear-bar-fill-width';
